import { toNumber, toText } from './helpers';
import type { MultiPolygonCoords, PolygonCoords, PolygonFeature, RawGreenFeatureProps } from './types';

export function normalizeFeature(input: unknown): PolygonFeature | null {
  if (!input || typeof input !== 'object') {
    return null;
  }

  const candidate = input as {
    type?: unknown;
    properties?: Partial<Record<keyof RawGreenFeatureProps, unknown>>;
    geometry?: {
      type?: unknown;
      coordinates?: unknown;
    };
  };

  const geometryType = toText(candidate.geometry?.type);
  if (geometryType !== 'Polygon' && geometryType !== 'MultiPolygon') {
    return null;
  }

  return {
    type: 'Feature',
    properties: {
      OBJECTID: toNumber(candidate.properties?.OBJECTID),
      Layer: toText(candidate.properties?.Layer),
      Shape_Leng: toNumber(candidate.properties?.Shape_Leng),
      Shape_Area: toNumber(candidate.properties?.Shape_Area),
      Region: toText(candidate.properties?.Region),
      SurveyDate: toText(candidate.properties?.SurveyDate),
      Maintenanc: toText(candidate.properties?.Maintenanc),
      TeamInform: toText(candidate.properties?.TeamInform),
      TeamLeader: toText(candidate.properties?.TeamLeader),
      WorkLog: toText(candidate.properties?.WorkLog),
      RoadLength: toNumber(candidate.properties?.RoadLength),
    },
    geometry: {
      type: geometryType,
      coordinates: (candidate.geometry?.coordinates ?? []) as PolygonCoords | MultiPolygonCoords,
    },
  };
}
